// src/components/AppIcon.jsx
import React from "react";
import { Box, Image } from "@mantine/core";
import { resolveIcon } from "../utils/iconResolver";

export default function AppIcon({
  styles,
  slot,
  boxSize = 100,
  radius = 0,
  fallback = null,
  alt,
}) {
  const icon = resolveIcon(styles, { slot });

  const frameProps = {
    w: boxSize,
    h: boxSize,
    style: { display: "grid", placeItems: "center", overflow: "hidden" },
  };

  if (!icon) return <Box {...frameProps}>{fallback}</Box>;

  const explicitW = typeof icon.width === "number" ? icon.width : undefined;
  const explicitH = typeof icon.height === "number" ? icon.height : undefined;

  return (
    <Box {...frameProps}>
      <Image
        src={icon.src}
        alt={alt || icon.alt || "Brand"}
        width={explicitW}
        height={explicitH}
        fit="contain"
        radius={radius}
        imageProps={{
          srcSet: icon.srcSet,   // Mantine 6: must be in imageProps
          sizes: `${boxSize}px`, // hint to the browser
          loading: "lazy",
          decoding: "async",
        }}
        styles={{
          image: { maxWidth: "100%", maxHeight: "100%", display: "block" },
          root: { width: "100%", height: "100%" },
        }}
      />
    </Box>
  );
}